$(document).ready(function () {
    var playVideo = false,
        slider = $('.main-slider');

    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const $currentSlide = $('.main-slider .slick-slide[data-slick-index="' + currentSlide + '"]'),
            $nextSlide = $('.main-slider .slick-slide[data-slick-index="' + nextSlide + '"]');

        var video = $nextSlide.find('video').get(0);
        $currentSlide.removeClass('main-slider__item_active');

        if (video && $(video).length) {
            playVideo = true;
        } else {
            if (!playVideo) return;
            playVideo = false;
            video = slider.find('video').get(0);
            video.pause();
            video.currentTime = 0;
        }
    });

    slider.on('afterChange', function (event, slick, currentSlide) {

        const $currentSlide = $('.main-slider .slick-slide[data-slick-index="' + currentSlide + '"]'),
            video = $currentSlide.find('video').get(0);

        $currentSlide.addClass('main-slider__item_active');

        if (!playVideo) return;
        video.play();
    });

    slider.on('init', function (event, slick) {
        const currentSlide = slick.currentSlide,
            $currentSlide = $('.main-slider .slick-slide[data-slick-index="' + currentSlide + '"]'),
            video = $currentSlide.find('video').get(0);

        if ($(video).length)
            video.play();

        $currentSlide.addClass('main-slider__item_active');

    });

});